export default {
  routes: [
    {
      // 更多参数url参数说明 https://doc.weixin.qq.com/doc/w3_AEgAqAY4AEcWAsvuVasQeuRaufnUF?scode=AJ4AfQfgAAwDbTFL1VAfoAMQbcAGg
      path: '/newcomer-area',
      name: 'newcomerArea',
      meta: {
        title: '新人专区',
        pageId: 'B1067'
      },
      component: () =>
        import(/* webpackChunkName: "newcomerArea" */ '../views/newcomerArea/index.vue')
    }
  ]
}
